import { CALL_API } from '@aftonbladet/redux-api-middleware';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';

import {
    COLLECTION_ARTICLES_REQUEST,
    COLLECTION_ARTICLES_SUCCESS,
    COLLECTION_ARTICLES_ADD,
    COLLECTION_ARTICLES_FAILURE,
} from './types';

/* eslint-disable import/prefer-default-export */
export const fetchCollectionArticlesAction = ({
    force = false,
    offset = 0,
    section = '',
    excludedSections = '',
    tag = '',
    story = '',
}) => {
    const {
        iris: { host },
    } = config;
    const endpoint = `${host}${
        config.iris.teasers
    }?offset=${offset}&limit=21&section=${section}&excludedSections=${excludedSections}&tag=${tag}&story=${story}`;

    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            types: [
                COLLECTION_ARTICLES_REQUEST,
                COLLECTION_ARTICLES_SUCCESS,
                COLLECTION_ARTICLES_FAILURE,
            ],
            bailout: (state) => !force && !!state.collectionArticles.collection.length,
        },
    };
};
/* eslint-enable import/prefer-default-export */

/* eslint-disable import/prefer-default-export */
export const addCollectionArticlesAction = ({
    offset = 0,
    section = '',
    excludedSections = '',
    tag = '',
    story = '',
}) => {
    const {
        iris: { host },
    } = config;
    const endpoint = `${host}${
        config.iris.teasers
    }?offset=${offset}&limit=21&section=${section}&excludedSections=${excludedSections}&tag=${tag}&story=${story}`;

    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            types: [
                COLLECTION_ARTICLES_REQUEST,
                COLLECTION_ARTICLES_ADD,
                COLLECTION_ARTICLES_FAILURE,
            ],
        },
    };
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/collection-articles.js
 **/